<template>
    <v-row>
        <DeleteJourney v-model="isDeleteDialogShown"
                       :journey-id="selectedJourneyIdToDelete"
                       @deleteJourneyRelatedDependencies="deleteJourneyRelatedDependencies($event)"/>
        <NewEditJourneyDialog :journey-id="selectedJourneyId" v-model="isNewEditDialogOpened"/>
        <v-col cols="12" class="d-flex justify-end align-center py-0">
            <v-text-field :label="$t('general.search')"
                          class="mr-6"
                          color="kbDarkBlue"
                          append-icon="mdi-magnify"
                          v-model="search"/>
            <v-tooltip bottom>
                <template v-slot:activator="{on}">
                    <v-btn class="mr-3"
                           color="mainButtons"
                           small
                           outlined
                           fab
                           v-on="on"
                           @click="changeCurrentView()">
                        <v-icon>{{ currentView === 'journey-list' ? 'mdi-format-list-bulleted' : 'mdi-sitemap' }}</v-icon>
                    </v-btn>
                </template>
                <span>{{ 'Change view' }}</span>
            </v-tooltip>
            <v-btn color="mainButtons" dark @click="addNewJourney()">{{$t('general.addNewJourney')}}</v-btn>
        </v-col>
        <v-col cols="12" class="py-0">
            <component :is="currentView"
                       :search="search"
                       @deleteJourney="deleteJourney($event)"
                       @editJourney="editJourney($event)"/>
        </v-col>
    </v-row>
</template>

<script>
import DeleteJourney from './dialogs/DeleteJourney'
import JourneyFlowChart from './JourneyFlowChart'
import JourneyList from './JourneyList'
import NewEditJourneyDialog from './dialogs/NewEditJourneyDialog'
import { mapState } from 'vuex'
export default {
  components: { DeleteJourney, JourneyFlowChart, JourneyList, NewEditJourneyDialog },
  computed: {
    ...mapState({
      journeys: state => state.journey.journeys
    })
  },
  data () {
    return {
      isDeleteDialogShown: false,
      isNewEditDialogOpened: false,
      currentView: 'journey-list',
      selectedJourneyId: '',
      loadingWorkFlow: false,
      search: '',
      selectedJourneyIdToDelete: ''
    }
  },
  methods: {
    addNewJourney () {
      this.isNewEditDialogOpened = true
    },
    async changeCurrentView () {
      if (this.currentView === 'journey-list') {
        this.currentView = 'journey-flow-chart'
      } else {
        this.currentView = 'journey-list'
      }
    },
    deleteJourney (journeyId) {
      this.isDeleteDialogShown = true
      this.selectedJourneyIdToDelete = journeyId
    },
    async deleteJourneyRelatedDependencies ($event) {
      const deletedJourneyId = $event

      const arrayOfPromises = []
      for (const journey of this.journeys) {
        if (journey.dependsOn.includes(deletedJourneyId)) {
          journey.dependsOn.splice(journey.dependsOn.indexOf(deletedJourneyId), 1)
          arrayOfPromises.push(
            this.$store.dispatch('updateDependsOn', {
              companyId: this.$route.params.companyid,
              appId: this.$route.params.appid,
              journeyId: journey.id,
              dependsOn: journey.dependsOn
            })
          )
        }
      }
      await Promise.all(arrayOfPromises)
    },
    editJourney (journeyId) {
      this.selectedJourneyId = journeyId
      this.isNewEditDialogOpened = true
    }
  },
  watch: {
    isDeleteDialogShown (newValue) {
      if (!newValue) {
        this.selectedJourneyIdToDelete = ''
      }
    },
    isNewEditDialogOpened (newValue) {
      if (!newValue) {
        this.selectedJourneyId = ''
      }
    }
  }
}
</script>
